import ActivateLanding from './activate-landing';
import BannerLanding from './banner-landing';
import BoxLanding from './box-landing';
import CardsLanding from './cards-landing';
import EduLanding from './edu-landing';
import CollaborateLanding from './collaborate-landing';
import './landing.css';
import NewsLanding from './news-landing';

import { useEffect,useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import AppContext from '../../AppContext';
import UserContext from '../../UserContext';
import {useNavigate} from 'react-router-dom';

function Landing({ landingPage }) {
	const navigate=useNavigate();
    const auth = useAuth();
    const appcontext = useContext(AppContext);
    const usercontext = useContext(UserContext);

    useEffect(() => {
	const checkPrimoAccesso=async function(){
		const user=usercontext.user;
		if(user.professione);else return navigate('/profilo/primoaccesso/?redirect='+encodeURIComponent(document.location.href));
	};
	if(usercontext && usercontext.user)
		checkPrimoAccesso();
    }, [appcontext,auth,usercontext,navigate]);


    return (
        <>
            <BannerLanding landingPage={landingPage} />
            {landingPage !== 'biblioteca-digitale' && landingPage !== 'edu' && <CardsLanding />}
            {landingPage === 'edu' && <EduLanding />}
            {landingPage !== 'biblioteca-digitale' && landingPage !=='edu' && (
                <div className='divider-landing'>
                    <hr />
                    <div>
                        <a href="#">Scopri tutte le novità <img src={`${process.env.PUBLIC_URL}/icon-arrow-blue.svg`} alt="Scopri tutte le novità" /></a>
                    </div>
                    <hr />
                </div>
            )}
            {landingPage !== 'edu' && <NewsLanding landingPage={landingPage} />}
            {landingPage !== 'professionali' && landingPage !== 'edu' && <ActivateLanding landingPage={landingPage} />}
            {landingPage !== 'edu' && <CollaborateLanding landingPage={landingPage}/>}
            {landingPage === 'edu' && <section className='content-landing'>
            <div className="collaborate-landing d-flex collaborate-landing-edu">
                <h2>Sei un docente? Accedi alla piattaforma</h2>
		<p>Scrivi a <a href='mailto:commerciale@giappichelli.it'>commerciale@giappichelli.it</a> per ricevere l'accesso alla piattaforma e visualizzare il contenuto della tua materia</p>
            </div>
        </section>}
        </>
    );
}

export default Landing;
